import React from 'react';
import PropTypes from 'prop-types';
import withStyles, { css } from '@bd/bdui-styles';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

export const defaultStyles = css``;

export function ContentBannerComponent({
  body,
  button,
  className,
  heading,
  media,
  postTitle,
  preTitle,
  subtitle,
  title,
  identity,
}) {
  return (
    <div className={`${className}`}>
      <div className="ContentBanner_wrapper" id={`${identity}`}>
        <div className="ContentBanner_inner">
          {
            heading &&
            <div className="ContentBanner_heading">{heading}</div>
          }
          <div className="ContentBanner_result">
            {
              media &&
              <div className="ContentBanner_resultMedia">
                {media}
              </div>
            }
            <div className="ContentBanner_resultContent">
              <h3 className="ContentBanner_title">
                <span className="ContentBanner_preTitle">{preTitle}</span>
                {title}
                <span className="ContentBanner_postTitle">{postTitle}</span>
              </h3>
              <h4 className="ContentBanner_subtitle">{subtitle}</h4>
              <div className="ContentBanner_body" dangerouslySetInnerHTML={SanitizeHtml(body)} />
              {
                React.isValidElement(button) &&
                button
              }
              {
                button &&
                !React.isValidElement(button) &&
                button.route &&
                <Link className="ContentBanner_link" name={button.route}>{button.children}</Link>
              }
              {
                button &&
                !React.isValidElement(button) &&
                button.path &&
                <a className="ContentBanner_link" href={button.path}>{button.children}</a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContentBannerComponent.propTypes = {
  /** Passed through SanitizeHtml and set on element using dangerouslySetInnerHTML */
  body: PropTypes.string,
  button: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({
      children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.string,
      ]).isRequired,
      route: PropTypes.string,
      path: PropTypes.string,
    }),
  ]),
  className: PropTypes.string,
  heading: PropTypes.string,
  /** Can be react element or html */
  media: PropTypes.node,
  postTitle: PropTypes.string,
  preTitle: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  identity: PropTypes.string,
};

ContentBannerComponent.defaultProps = {
  body: undefined,
  button: undefined,
  className: '',
  heading: undefined,
  media: undefined,
  postTitle: undefined,
  preTitle: undefined,
  subtitle: undefined,
  title: undefined,
  identity: undefined,
};

export default withStyles(defaultStyles)(ContentBannerComponent);



// WEBPACK FOOTER //
// ./src/components/ContentBanner.js